"use client";

import { getVestingTimeRemaining } from "@/utils";
import { ClaimResult, DEFAULT_CLAIM_ERROR } from "@/utils/contract-errors";
import { useState } from "react";
import SecondaryButton from "../../SecondaryButton/SecondaryButton";

export default function ClaimScreen({
  onNext,
  // isStaking,
  allocatedSpon,
  isVestedClaim,
  onCancel,
  onClaim,
  onVestedClaim,
}: // onStake,
{
  onNext: () => void;
  allocatedSpon: number;
  onClaim: () => Promise<ClaimResult>;
  onVestedClaim: () => Promise<ClaimResult>;
  onStake: () => Promise<boolean>;
  isStaking: boolean;
  isVestedClaim: boolean;
  onCancel: () => void;
}) {
  const [status, setStatus] = useState<"idle" | "loading" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState(DEFAULT_CLAIM_ERROR);

  const claim = async () => {
    setStatus("loading");
    const result = isVestedClaim ? await onVestedClaim() : await onClaim();
    if (!result.success) {
      setErrorMessage(result.message);
      setStatus("error");
      return;
    }
    onNext();
    setStatus("idle");
  };

  // const claimAndStake = async () => {
  //   setIsLoading(true);
  //   // await onClaim();
  //   // await onStake();
  //   onNext();
  //   setIsLoading(false);
  // };

  const timeLeft = getVestingTimeRemaining();

  const formattedTimeRemaining = `${
    timeLeft.days > 0 ? timeLeft.days + "d" : ""
  } ${timeLeft.hours > 0 ? timeLeft.hours + "h" : ""} ${timeLeft.minutes}m`;

  return (
    <>
      <div className="flex flex-col gap-y-6">
        <p className="font-albert-sans text-2xl leading-7 text-white text-center">
          CLAIM {Number(allocatedSpon.toFixed(6))} SPON
        </p>
      </div>
      <div className="flex flex-col gap-4 text-[#9D9D9D]">
        {/* {!isVestedClaim && (
          <ul className="space-y-2 list-disc pl-4">
            <li>You get 20% as a Fizzer in the network</li>
            <li>
              after that, you will get SPON token in linear unlocking over 6
              months
            </li>
          </ul>
        )} */}
        <p>
          Before you proceed to claim, we'd like to take a moment to sincerely
          thank you for being a part of the Spheron Network.
        </p>
        <p>
          Your support in contributing your resources plays a vital role in
          powering our decentralized infrastructure. We're equally grateful for
          your curiosity and engagement in exploring the broader Spheron
          ecosystem.{" "}
        </p>
        <p>
          It's builders and supporters like you who are helping us shape the
          future of open, accessible compute for everyone.
        </p>
        {/* <p>
          You can claim{" "}
          <span className="text-white font-semibold">
            {allocatedSpon.toFixed(2)} SPON
          </span>
          .{" "}
 {!isVestedClaim &&
            "But we would recommend you to stake your tokens to earn early staking reward and some additional bonus rewards."} 
        </p> */}

        {isVestedClaim && (
          <div className="bg-white/5 border border-[#444] p-4 flex flex-col gap-2 shadow-sm">
            <div>
              Unlocked So Far:{" "}
              <span className="font-semibold text-white">
                {allocatedSpon.toFixed(6)} SPON
              </span>
            </div>
            <div>
              Unlocking Time Remaining:{" "}
              <span className="font-semibold text-white">
                {formattedTimeRemaining}
              </span>
            </div>
          </div>
        )}

        <div className="w-full flex flex-row gap-4 mt-4">
          <SecondaryButton
            // loading={isLoading}
            onClick={() => {
              onCancel();
            }}
            variant="dark"
          >
            Cancel
          </SecondaryButton>
          {/* {!isStaking && ( */}
          <SecondaryButton
            loading={status === "loading"}
            onClick={() => {
              claim();
            }}
            variant="light"
          >
            Claim SPON{/*  {isStSpon ? "" : "anyway"} */}
          </SecondaryButton>
          {/* )} */}

          {/* {!isStSpon && (
            <SecondaryButton
              disabled={!isChecked}
              loading={isLoading}
              onClick={() => {
                claimAndStake();
              }}
              variant="light"
            >
              Claim and Stake
            </SecondaryButton>
          )} */}
        </div>
        {status === "error" ? (
          <div className="text-red-600 text-xs">{errorMessage}</div>
        ) : null}
      </div>
    </>
  );
}
